import script from "./GeneratedComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneratedComponent.vue?vue&type=script&setup=true&lang=js"

import "./GeneratedComponent.vue?vue&type=style&index=0&id=1c363ebd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c363ebd"]])

export default __exports__